export const MSP_DAILY_CREDITS = 25;
export const MSP_MINIMUM_CREDIT_DAYS = 60;

// Organization service status keeps this legacy response key for its Site
// summary. It must not be used in Site-level gates or write requests.
export const ORG_SERVICE_STATUS_PRO_KEY = "nmsPro";

// Site service status and all service subscription requests use this key.
export const UNITY_PRO_SERVICE_KEY = "unityPro";
export const UNITY_PRO_ACCESS_POINT_DAILY_CREDITS = 2;
export const UNITY_PRO_SWITCH_DAILY_CREDITS = 2;

// API request actions and the normalized UI status labels are deliberately
// separate: the API uses lowercase verbs, while UI state uses title case.
export const LICENSE_SERVICE_ACTION_ACTIVE = "active";
export const LICENSE_SERVICE_ACTION_DEACTIVE = "deactive";
export const LICENSE_SERVICE_STATUS_ACTIVE = "Active";
export const LICENSE_SERVICE_STATUS_INACTIVE = "Inactive";

export const LICENSE_TRANSACTION_TYPE = {
  IMPORT: "import",
  SUBSCRIBE: "subscribe",
  MONTHLY_CHARGE: "monthlyCharge",
  ADDED_DEVICE: "addDevice",
  REMOVE_DEVICE: "removeDevice",
  UNSUBSCRIBE: "unsubscribe",
  PURCHASE: "purchase",
  REVERSAL: "reversal",
  COVER_CURRENT_MONTH: "coverCurrentMonth",
  PARTIAL_GRANT: "partialGrant",
  MSP_DISBURSEMENT: "mspDisbursement",
  MSP_WITHDRAWAL: "mspWithdrawal",
  COMPENSATORY_KEY_ISSUED: "compensatoryKeyIssued",
  MANUAL_ADJUSTMENT: "manualAdjustment",
};

const LICENSE_TRANSACTION_TYPE_LABELS = {
  [LICENSE_TRANSACTION_TYPE.IMPORT]: "Import",
  [LICENSE_TRANSACTION_TYPE.SUBSCRIBE]: "Subscribe",
  monthlycharge: "Monthly Charge",
  [LICENSE_TRANSACTION_TYPE.ADDED_DEVICE]: "Added Device",
  [LICENSE_TRANSACTION_TYPE.REMOVE_DEVICE]: "Remove Device",
  [LICENSE_TRANSACTION_TYPE.UNSUBSCRIBE]: "Unsubscribe",
  [LICENSE_TRANSACTION_TYPE.PURCHASE]: "Purchase",
  [LICENSE_TRANSACTION_TYPE.REVERSAL]: "Reversal",
  [LICENSE_TRANSACTION_TYPE.COVER_CURRENT_MONTH]: "Cover Current Month",
  [LICENSE_TRANSACTION_TYPE.PARTIAL_GRANT]: "Partial Grant",
  [LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT]: "MSP Disbursement",
  [LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL]: "MSP Withdrawal",
  [LICENSE_TRANSACTION_TYPE.COMPENSATORY_KEY_ISSUED]: "Compensatory Key Issued",
  [LICENSE_TRANSACTION_TYPE.MANUAL_ADJUSTMENT]: "Manual Adjustment",
};

export const getLicenseTransactionTypeLabel = (type) => {
  if (!type) return "";
  return LICENSE_TRANSACTION_TYPE_LABELS[normalizeLicenseTransactionType(type)] || type;
};

export const normalizeLicenseTransactionType = (type) => {
  const value = String(type || "").toLowerCase();
  const normalizedTypes = {
    import: LICENSE_TRANSACTION_TYPE.IMPORT,
    deposit: LICENSE_TRANSACTION_TYPE.IMPORT,
    subscribe: LICENSE_TRANSACTION_TYPE.SUBSCRIBE,
    monthlycharge: LICENSE_TRANSACTION_TYPE.MONTHLY_CHARGE,
    adddevice: LICENSE_TRANSACTION_TYPE.ADDED_DEVICE,
    removedevice: LICENSE_TRANSACTION_TYPE.REMOVE_DEVICE,
    unsubscribe: LICENSE_TRANSACTION_TYPE.UNSUBSCRIBE,
    purchase: LICENSE_TRANSACTION_TYPE.PURCHASE,
    reversal: LICENSE_TRANSACTION_TYPE.REVERSAL,
    covercurrentmonth: LICENSE_TRANSACTION_TYPE.COVER_CURRENT_MONTH,
    partialgrant: LICENSE_TRANSACTION_TYPE.PARTIAL_GRANT,
    mspdisbursement: LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT,
    mspwithdrawal: LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL,
    compensatorykeyissued: LICENSE_TRANSACTION_TYPE.COMPENSATORY_KEY_ISSUED,
    manualadjustment: LICENSE_TRANSACTION_TYPE.MANUAL_ADJUSTMENT,
    mspdisbursementinorg: LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT,
    mspdisbursementinmsp: LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT,
    mspwithdrawalinorg: LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL,
    mspwithdrawalinmsp: LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL,
  };
  return normalizedTypes[value] || type;
};

export const ORG_TRANSACTION_TYPE_OPTIONS = [
  { name: "Import", value: LICENSE_TRANSACTION_TYPE.IMPORT },
  { name: "Subscribe", value: LICENSE_TRANSACTION_TYPE.SUBSCRIBE },
  { name: "Monthly Charge", value: LICENSE_TRANSACTION_TYPE.MONTHLY_CHARGE },
  { name: "Added Device", value: LICENSE_TRANSACTION_TYPE.ADDED_DEVICE },
  { name: "Remove Device", value: LICENSE_TRANSACTION_TYPE.REMOVE_DEVICE },
  { name: "Unsubscribe", value: LICENSE_TRANSACTION_TYPE.UNSUBSCRIBE },
  // { name: "Purchase", value: LICENSE_TRANSACTION_TYPE.PURCHASE }, 
  // { name: "Reversal", value: LICENSE_TRANSACTION_TYPE.REVERSAL },
  { name: "Cover Current Month", value: LICENSE_TRANSACTION_TYPE.COVER_CURRENT_MONTH },
  { name: "Partial Grant", value: LICENSE_TRANSACTION_TYPE.PARTIAL_GRANT },
  { name: "MSP Disbursement", value: LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT },
  { name: "MSP Withdrawal", value: LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL },
  // { name: "Manual Adjustment", value: LICENSE_TRANSACTION_TYPE.MANUAL_ADJUSTMENT },
];

export const MSP_TRANSACTION_TYPE_OPTIONS = [
  { name: "Import", value: LICENSE_TRANSACTION_TYPE.IMPORT },
  { name: "Subscribe", value: LICENSE_TRANSACTION_TYPE.SUBSCRIBE },
  { name: "Monthly Charge", value: LICENSE_TRANSACTION_TYPE.MONTHLY_CHARGE },
  { name: "Cover Current Month", value: LICENSE_TRANSACTION_TYPE.COVER_CURRENT_MONTH },
  { name: "Partial Grant", value: LICENSE_TRANSACTION_TYPE.PARTIAL_GRANT },
  // { name: "Purchase", value: LICENSE_TRANSACTION_TYPE.PURCHASE },
  // { name: "Reversal", value: LICENSE_TRANSACTION_TYPE.REVERSAL },
  { name: "MSP Disbursement", value: LICENSE_TRANSACTION_TYPE.MSP_DISBURSEMENT },
  { name: "MSP Withdrawal", value: LICENSE_TRANSACTION_TYPE.MSP_WITHDRAWAL },
  // { name: "Compensatory Key Issued", value: LICENSE_TRANSACTION_TYPE.COMPENSATORY_KEY_ISSUED },
  // { name: "Manual Adjustment", value: LICENSE_TRANSACTION_TYPE.MANUAL_ADJUSTMENT },
];
